<template>
  <v-navigation-drawer
    :mini-variant="isMini"
    app
    class="grey lighten-3"
    fixed
    mini-variant-width="150"
    width="230"
  >
    <v-app-bar
      class="elevation-0"
      color="primary darken-1"
      dark
    >
      <v-app-bar-nav-icon
        class="side-icon"
        dark
        @click.stop="SET_MINI(!isMini)"
      >
        <v-icon>fal fa-align-left</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title
        v-if="!isMini"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Vaporshop</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-list
      class="grey-lighten-3"
      dense
    >
      <template v-for="(item, i) in menu">
        <!-- group with subitems -->
        <v-menu
          v-if="item.children"
          :key="i"
          close-delay="300"
          offset-x
          open-on-hover
        >
          <v-list-item
            slot="activator"
            class="pt-2 pb-2"
          >
            <v-list-item-action class="align-center">
              <v-icon>{{ item.icon }}</v-icon>
              <div
                v-show="isMini"
                class="mt-2 text-caption"
              >{{ $t(item.text) }}</div>
            </v-list-item-action>
            <v-list-item-content v-show="!isMini">
              <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list dense>
            <template v-for="(subitem, j) in item.children">
              <v-list-item
                :key="j"
                :to="subitem.to"
                exact
              >
                <v-list-item-action v-if="subitem.icon">
                  <v-icon>{{ subitem.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title><span>{{ $t(subitem.text) }}</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>

        <!-- root level item -->
        <v-list-item
          v-else
          :key="i"
          :to="item.to"
          class="pt-2 pb-2"
          exact
        >
          <v-list-item-action class="align-center">
            <v-badge
              v-if="item.showItemCount && itemCount"
              :content="abbrCount"
              :offset-x="20"
              bordered
              class="badge-border-grey"
              color="primary"
              overlap
            />
            <v-icon>{{ item.icon }}</v-icon>
            <div
              v-show="isMini"
              class="mt-2 text-caption"
            >{{ $t(item.text) }}</div>
          </v-list-item-action>
          <v-list-item-content v-show="!isMini">
            <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <template v-slot:append>
      <div class="text-center">
        <full-screen-switcher class="mb-2" />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import NumAbbr from 'number-abbreviate'
import { mapActions, mapGetters } from 'vuex'
import menu from '@/utils/menu-sidebar'
import FullScreenSwitcher from '@/components/FullScreenSwitcher'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  name: 'AppSidebar',

  components: {
    LanguageSwitcher,
    FullScreenSwitcher
  },

  data () {
    return {
      menu: menu
    }
  },

  computed: {
    ...mapGetters('RECEIPT', ['itemCount']),
    ...mapGetters('AUTH', ['user']),
    abbrCount () {
      return NumAbbr(this.itemCount)
    },
    isMini: {
      get () {
        return this.$store.state.isMini
      },
      set (newValue) {
        this.$store.dispatch('SET_MINI', newValue)
      }
    }
  },

  methods: {
    ...mapActions(['SET_MINI'])
  }
}
</script>

<style lang="scss" scoped>
  .v-navigation-drawer {
    /deep/ .v-list__item {
      height: auto;
    }

    /deep/ .v-badge__badge {
      font-size: 11px;
    }
  }

  .v-navigation-drawer--mini-variant {
    /deep/ .v-list__item__action {
      width: 100%;
    }

    /deep/ .v-menu__activator > div {
      width: 100%;
    }

    .side-icon {
      margin: auto auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AppSidebar.vue